export default __webpack_public_path__ + "static/media/hb104.7f44769d.jpg";